import { render, staticRenderFns } from "./Article32.vue?vue&type=template&id=4e8d7e56&"
import script from "./Article32.vue?vue&type=script&lang=js&"
export * from "./Article32.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports